"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanMatcherContext = void 0;
function booleanMatcherContext(ruleAttr) {
    return function booleanMatcher(runtimeAttr) {
        var booleanMatches = ruleAttr === runtimeAttr;
        return booleanMatches;
    };
}
exports.booleanMatcherContext = booleanMatcherContext;
